export const NAVIGATION_TEST_IDS = {
    MAIN_LOGO: "top-left-logo",
    MAIN_ELEMENT: "navigation-container",
    FIRST_LVL_ELEMENT: "navigation-first-level-element",
    SECOND_LVL_ELEMENT: "navigation-second-level-element",
    THIRD_LVL_ELEMENT: "navigation-third-level-element",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    LISTING_CHANGING_BUTTON: "listing-changing-button",
    USER_ICON: "user-icon",
    FAVOURITES: {
        BUTTON: "topbar-favourites-button",
        BADGE: "topbar-favourites-badge",
        DROPDOWN: "topbar-favourites-dropdown",
        CARD: "topbar-favourites-card",
        CARD_REMOVE: "topbar-favourites-card-remove",
        SHOW_ALL: "topbar-favourites-show-all",
        EMPTY_SEARCH: "topbar-favourites-empty-search"
    },
    SEARCH_BAR: {
        INPUT: "search-autocomplete",
        COUNTRY_TAB: "country-tab",
        RESULT_ITEM: "results-list-item",
        DROPDOWN: "search-autocomplete-dropdown",
        SEARCH_BUTTON: "searchBarSearchButton",
        INVESTMENT: "search-bar-investment"
    },
    SORT_ICON: "sort-icon",
    BURGER_MENU: "burger-menu",
    SORT_BUTTON: "sort-button",
    SORT_SELECT_BUTTON: "sort-select-button"
};

export const NAVIGATION_MOBILE_TEST_IDS = {
    FAVOURITES: {
        BUTTON: "topbar-favourites-button-mobile",
        BADGE: "topbar-favourites-badge-mobile"
    },
    SEARCH_BAR: {
        INPUT: "search-autocomplete-mobile",
        COUNTRY_TAB: "country-tab-mobile",
        // Mobile homepage hero submit and its counterpart inside the search modal. Both mean "submit
        // the mobile search" and only one of them renders at a time.
        SEARCH_BUTTON: "search-bar-search-button-mobile"
    }
};

export const FOOTER_TEST_IDS = {
    FOOTER_ELEMENT: "footer-nav-container",
    FOOTER_SOCIAL_ICON: "social-media-icon",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    PANEL_EXPAND_WRAPPER: "panel-expandable-wrapper",
    PANEL_EXPANDABLE: "panel-expandable"
};

export const COOKIES_MODAL_IDS = {
    // TODO(QA-279): not found in any app or package; likely rendered by the third-party Cookiebot script. Verify.
    MODAL_BOX: "CybotCookiebotDialog",
    // TODO(QA-279): not found in any app or package; likely rendered by the third-party Cookiebot script. Verify.
    ACCEPT_BUTTON: "CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
};

export const FILTERS_TEST_IDS = {
    FILTERS_BOX: "filters-box",
    AREA: "filters-area",
    ACCEPT_BUTTON: "filters-accept-button",
    CLEAN_BUTTON: "filters-clean-button",
    DELIVERY_DATE: "filters-delivery-date",
    ROOMS: "filters-rooms",
    FLOORS: "filters-floors",
    AREA_SIZE: "filters-area-size",
    FILTER_MOBILE_ICON: "filters-mobile-icon",
    HOUSE_TYPES: "filters-house-types",
    ADDITIONAL_SURFACES: "filters-additional-surfaces"
};

export const PROPERTY_CONFIGURATOR_TEST_IDS = {
    NEXT_BUTTON: "property-configurator-next-button",
    PREV_BUTTON: "property-configurator-prev-button",
    ROOM_OPTION: "room-selection-option",
    TOTAL_INPUT: "total-input",
    MONTHLY_INPUT: "monthly-input",
    FAVOURITE_ICON: "favourite-icon"
};

export const HOMEPAGE_TEST_IDS = {
    RECOMMENDED_OFFERS: {
        MORE_OFFERS_BOX: "more-offers-box"
    },
    BLOG_CATEGORIES: {
        VIEW_ARTICLES_BUTTON: "homepage-blog-category-button"
    },
    ARCHITECTS_BUTTON: "homepage-architects-button"
};

export const LISTING_VENDOR_TEST_IDS = {
    CARD: "listing-vendor-card",
    FAVOURITE_ICON: "favourite-icon",
    FIRST_LISTING_ELEMENT: "first-listing-element",
    MAP_CONTAINER: "listing-vendor-map-container",
    PROPERTY_CARD_IMAGE: "property-card-image",
    PROPERTY_CONTAINER: "property-container"
};

export const VENDOR_DETAIL_TEST_IDS = {
    ASK_DEVELOPER_BUTTON: "ask-developer-button"
};

export const PREFERENCES_SURVEY_MODAL_TEST_IDS = {
    WRAPPER: "preferences-survey-modal",
    HEADER_BOX: "preferences-survey-header-box",
    LOCATION_FIELD: "preferences-survey-location",
    SAVE_PREFERENCES_BUTTON: "preferences-survey-save-button",
    SUMMARY_BUTTON: "preferences-survey-summary-button",
    SUMMARY_MODAL: "preferences-survey-summary-modal",
    CLOSE_BUTTON: "preferences-survey-close-button",
    BUDGET_INPUT: "preferences-survey-budget-input",
    CREDIT_PLAN_SWITCH: "preferences-survey-credit-plan-switch"
};

export const HOME_MATCH_BASIC_SUMMARY_TEST_IDS = {
    WRAPPER: "home-match-basic-summary-modal",
    CLOSE_BUTTON: "home-match-basic-summary-close-button",
    PREFERENCES_TEXT: "home-match-basic-summary-preferences-text",
    EDIT_PREFERENCES_BUTTON: "home-match-basic-summary-edit-preferences-button",
    AUTO_MATCH_SWITCH: "home-match-basic-summary-auto-match-switch",
    CONFIRM_BUTTON: "home-match-basic-summary-confirm-button"
};

export const HOME_MATCH_BASIC_RESIGNATION_TEST_IDS = {
    WRAPPER: "home-match-basic-resignation-modal",
    CLOSE_BUTTON: "home-match-basic-resignation-close-button",
    KEEP_ENABLED_BUTTON: "home-match-basic-resignation-keep-enabled-button",
    DISABLE_BUTTON: "home-match-basic-resignation-disable-button"
};

export const MULTILEAD_RESPONSIVE_MODAL_TEST_IDS = {
    WRAPPER: "multilead-responsive-modal",
    LOADER: "multilead-responsive-modal-loader",
    CLOSE_BUTTON: "multilead-responsive-modal-close-button",
    PROPERTY_CARD: "multilead-responsive-modal-property-card",
    PROPERTY_CHECKBOX: "multilead-responsive-modal-property-checkbox",
    MAP: "multilead-responsive-modal-map",
    INVALID_DATA_MESSAGE: "multilead-responsive-modal-invalid-data-message",
    SHOW_USER_DATA_FORM_BUTTON: "multilead-responsive-modal-show-user-data-form-button",
    SHOW_RECOMMENDATIONS_BUTTON: "multilead-responsive-modal-show-recommendations-button",
    NAME_INPUT: "multilead-responsive-modal-name-input",
    EMAIL_INPUT: "multilead-responsive-modal-email-input",
    PHONE_INPUT: "multilead-responsive-modal-phone-input"
};

export const SENT_APPLICATIONS_SUMMARY_TEST_IDS = {
    WRAPPER: "sent-applications-summary-modal",
    CLOSE_BUTTON: "sent-applications-summary-close-button",
    PROPERTY_CARD: "sent-applications-summary-property-card",
    PREVIOUS_BUTTON: "sent-applications-summary-previous-button",
    NEXT_BUTTON: "sent-applications-summary-next-button"
};

export const REGISTRATION_WIZARD_TEST_IDS = {
    STEP_INDICATOR: "registration-wizard-step-indicator",
    BACK_BUTTON: "registration-wizard-back-button",
    STEP_TITLE: "registration-wizard-step-title",
    EMAIL_INPUT: "registration-wizard-email-input",
    EMAIL_SUBMIT_BUTTON: "registration-wizard-email-submit-button",
    GOOGLE_BUTTON: "registration-wizard-google-button",
    FACEBOOK_BUTTON: "registration-wizard-facebook-button",
    PHONE_INPUT: "registration-wizard-phone-input",
    PHONE_SUBMIT_BUTTON: "registration-wizard-phone-submit-button",
    SMS_CODE_INPUT: "registration-wizard-sms-code-input",
    SMS_RESEND_BUTTON: "registration-wizard-sms-resend-button",
    SMS_ERROR: "registration-wizard-sms-error",
    NAME_INPUT: "registration-wizard-name-input",
    NAME_SUBMIT_BUTTON: "registration-wizard-name-submit-button"
};
export const NAVIGATION_TEST_IDS = {
    MAIN_LOGO: "top-left-logo",
    MAIN_ELEMENT: "navigation-container",
    FIRST_LVL_ELEMENT: "navigation-first-level-element",
    SECOND_LVL_ELEMENT: "navigation-second-level-element",
    THIRD_LVL_ELEMENT: "navigation-third-level-element",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    LISTING_CHANGING_BUTTON: "listing-changing-button",
    USER_ICON: "user-icon",
    FAVOURITES: {
        BUTTON: "topbar-favourites-button",
        BADGE: "topbar-favourites-badge",
        DROPDOWN: "topbar-favourites-dropdown",
        CARD: "topbar-favourites-card",
        CARD_REMOVE: "topbar-favourites-card-remove",
        SHOW_ALL: "topbar-favourites-show-all",
        EMPTY_SEARCH: "topbar-favourites-empty-search"
    },
    SEARCH_BAR: {
        INPUT: "search-autocomplete",
        COUNTRY_TAB: "country-tab",
        RESULT_ITEM: "results-list-item",
        DROPDOWN: "search-autocomplete-dropdown",
        SEARCH_BUTTON: "searchBarSearchButton",
        INVESTMENT: "search-bar-investment"
    },
    SORT_ICON: "sort-icon",
    BURGER_MENU: "burger-menu",
    SORT_BUTTON: "sort-button",
    SORT_SELECT_BUTTON: "sort-select-button"
};

export const NAVIGATION_MOBILE_TEST_IDS = {
    FAVOURITES: {
        BUTTON: "topbar-favourites-button-mobile",
        BADGE: "topbar-favourites-badge-mobile"
    },
    SEARCH_BAR: {
        INPUT: "search-autocomplete-mobile",
        COUNTRY_TAB: "country-tab-mobile",
        // Mobile homepage hero submit and its counterpart inside the search modal. Both mean "submit
        // the mobile search" and only one of them renders at a time.
        SEARCH_BUTTON: "search-bar-search-button-mobile"
    }
};

export const FOOTER_TEST_IDS = {
    FOOTER_ELEMENT: "footer-nav-container",
    FOOTER_SOCIAL_ICON: "social-media-icon",
    // TODO(QA-279): no app or package renders this id (origin/dev, 2026-09-30). Verify: fix the value or the test, or remove the id.
    PANEL_EXPAND_WRAPPER: "panel-expandable-wrapper",
    PANEL_EXPANDABLE: "panel-expandable"
};

export const COOKIES_MODAL_IDS = {
    // TODO(QA-279): not found in any app or package; likely rendered by the third-party Cookiebot script. Verify.
    MODAL_BOX: "CybotCookiebotDialog",
    // TODO(QA-279): not found in any app or package; likely rendered by the third-party Cookiebot script. Verify.
    ACCEPT_BUTTON: "CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll"
};

export const FILTERS_TEST_IDS = {
    FILTERS_BOX: "filters-box",
    AREA: "filters-area",
    ACCEPT_BUTTON: "filters-accept-button",
    CLEAN_BUTTON: "filters-clean-button",
    DELIVERY_DATE: "filters-delivery-date",
    ROOMS: "filters-rooms",
    FLOORS: "filters-floors",
    AREA_SIZE: "filters-area-size",
    FILTER_MOBILE_ICON: "filters-mobile-icon",
    HOUSE_TYPES: "filters-house-types",
    ADDITIONAL_SURFACES: "filters-additional-surfaces"
};

export const PROPERTY_CONFIGURATOR_TEST_IDS = {
    NEXT_BUTTON: "property-configurator-next-button",
    PREV_BUTTON: "property-configurator-prev-button",
    ROOM_OPTION: "room-selection-option",
    TOTAL_INPUT: "total-input",
    MONTHLY_INPUT: "monthly-input",
    FAVOURITE_ICON: "favourite-icon"
};

export const HOMEPAGE_TEST_IDS = {
    RECOMMENDED_OFFERS: {
        MORE_OFFERS_BOX: "more-offers-box"
    },
    BLOG_CATEGORIES: {
        VIEW_ARTICLES_BUTTON: "homepage-blog-category-button"
    },
    ARCHITECTS_BUTTON: "homepage-architects-button"
};

export const LISTING_VENDOR_TEST_IDS = {
    CARD: "listing-vendor-card",
    FAVOURITE_ICON: "favourite-icon",
    FIRST_LISTING_ELEMENT: "first-listing-element",
    MAP_CONTAINER: "listing-vendor-map-container",
    PROPERTY_CARD_IMAGE: "property-card-image",
    PROPERTY_CONTAINER: "property-container"
};

export const VENDOR_DETAIL_TEST_IDS = {
    ASK_DEVELOPER_BUTTON: "ask-developer-button"
};

export const PREFERENCES_SURVEY_MODAL_TEST_IDS = {
    WRAPPER: "preferences-survey-modal",
    HEADER_BOX: "preferences-survey-header-box",
    LOCATION_FIELD: "preferences-survey-location",
    SAVE_PREFERENCES_BUTTON: "preferences-survey-save-button",
    SUMMARY_BUTTON: "preferences-survey-summary-button",
    SUMMARY_MODAL: "preferences-survey-summary-modal",
    CLOSE_BUTTON: "preferences-survey-close-button",
    BUDGET_INPUT: "preferences-survey-budget-input",
    CREDIT_PLAN_SWITCH: "preferences-survey-credit-plan-switch"
};

export const HOME_MATCH_BASIC_SUMMARY_TEST_IDS = {
    WRAPPER: "home-match-basic-summary-modal",
    CLOSE_BUTTON: "home-match-basic-summary-close-button",
    PREFERENCES_TEXT: "home-match-basic-summary-preferences-text",
    EDIT_PREFERENCES_BUTTON: "home-match-basic-summary-edit-preferences-button",
    AUTO_MATCH_SWITCH: "home-match-basic-summary-auto-match-switch",
    CONFIRM_BUTTON: "home-match-basic-summary-confirm-button"
};

export const HOME_MATCH_BASIC_RESIGNATION_TEST_IDS = {
    WRAPPER: "home-match-basic-resignation-modal",
    CLOSE_BUTTON: "home-match-basic-resignation-close-button",
    KEEP_ENABLED_BUTTON: "home-match-basic-resignation-keep-enabled-button",
    DISABLE_BUTTON: "home-match-basic-resignation-disable-button"
};

export const MULTILEAD_RESPONSIVE_MODAL_TEST_IDS = {
    WRAPPER: "multilead-responsive-modal",
    LOADER: "multilead-responsive-modal-loader",
    CLOSE_BUTTON: "multilead-responsive-modal-close-button",
    PROPERTY_CARD: "multilead-responsive-modal-property-card",
    PROPERTY_CHECKBOX: "multilead-responsive-modal-property-checkbox",
    MAP: "multilead-responsive-modal-map",
    INVALID_DATA_MESSAGE: "multilead-responsive-modal-invalid-data-message",
    SHOW_USER_DATA_FORM_BUTTON: "multilead-responsive-modal-show-user-data-form-button",
    SHOW_RECOMMENDATIONS_BUTTON: "multilead-responsive-modal-show-recommendations-button",
    NAME_INPUT: "multilead-responsive-modal-name-input",
    EMAIL_INPUT: "multilead-responsive-modal-email-input",
    PHONE_INPUT: "multilead-responsive-modal-phone-input"
};

export const SENT_APPLICATIONS_SUMMARY_TEST_IDS = {
    WRAPPER: "sent-applications-summary-modal",
    CLOSE_BUTTON: "sent-applications-summary-close-button",
    PROPERTY_CARD: "sent-applications-summary-property-card",
    PREVIOUS_BUTTON: "sent-applications-summary-previous-button",
    NEXT_BUTTON: "sent-applications-summary-next-button"
};

export const REGISTRATION_WIZARD_TEST_IDS = {
    STEP_INDICATOR: "registration-wizard-step-indicator",
    BACK_BUTTON: "registration-wizard-back-button",
    STEP_TITLE: "registration-wizard-step-title",
    EMAIL_INPUT: "registration-wizard-email-input",
    EMAIL_SUBMIT_BUTTON: "registration-wizard-email-submit-button",
    GOOGLE_BUTTON: "registration-wizard-google-button",
    FACEBOOK_BUTTON: "registration-wizard-facebook-button",
    PHONE_INPUT: "registration-wizard-phone-input",
    PHONE_SUBMIT_BUTTON: "registration-wizard-phone-submit-button",
    SMS_CODE_INPUT: "registration-wizard-sms-code-input",
    SMS_RESEND_BUTTON: "registration-wizard-sms-resend-button",
    SMS_ERROR: "registration-wizard-sms-error",
    NAME_INPUT: "registration-wizard-name-input",
    NAME_SUBMIT_BUTTON: "registration-wizard-name-submit-button"
};
